import React, { ReactNode } from "react";

interface ConfirmationModalProps {
  isOpen: boolean;
  onOk: () => void;
  onCancel: () => void;
  ConfirmationHeading: string;
  ConfirmationParagraph: string;
  icon?: ReactNode;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onOk,
  onCancel,
  ConfirmationHeading,
  ConfirmationParagraph,
  icon,
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-50 bg-black/50"
        onClick={onCancel}
      />
      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none">
        <div
          className="w-full max-w-[300px] bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700 rounded-xl shadow-md pointer-events-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="px-4 pt-4 pb-3 border-b border-slate-100 dark:border-slate-700 flex items-center gap-2">
            {icon && <span className="text-slate-500 dark:text-slate-400">{icon}</span>}
            <h3 className="text-sm font-medium text-slate-900 dark:text-white">
              {ConfirmationHeading}
            </h3>
          </div>
          <div className="px-4 py-4">
            <p className="text-sm text-slate-600 dark:text-slate-300">
              {ConfirmationParagraph}
            </p>
          </div>
          <div className="flex items-center gap-2 px-4 pb-4">
            <button
              onClick={onCancel}
              className="flex-1 px-4 py-2 text-sm font-medium rounded-lg border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-700 hover:bg-slate-50 dark:hover:bg-slate-600 transition-colors"
            >
              No
            </button>
            <button
              onClick={onOk}
              className="flex-1 px-4 py-2 text-sm font-medium rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmationModal;
